import React, { useState, useEffect } from 'react';
import { RxCross1 } from "react-icons/rx";
import { useCurrency } from '../../Layouts/currencyContext';

const DirectPurchaseViewGrid = ({ itemData, currencyPrecision }) => {
    const totalAmount = itemData?.grnDetails.reduce((sum, row) => sum + (parseFloat(row?.amount - row?.vatAmount) || 0), 0)
    const totalVat = itemData?.grnDetails.reduce((sum, row) => sum + (parseFloat(row?.vatAmount) || 0), 0)
    const netAmount = itemData?.grnDetails.reduce((sum, row) => sum + (parseFloat(row?.amount) || 0), 0)

    return (
        <div>
            <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
                <table>
                    <thead className='dynoTable' >
                        <tr>
                            <th></th>
                            <th>Sr no</th>
                            <th>Item No</th>
                            <th>Description</th>
                            <th>Item Specs</th>
                            <th>Qty</th>
                            <th>Packing UOM</th>
                            <th>Inventory Qty</th>
                            <th>Unit Price</th>
                            <th>Discount</th>
                            <th>VAT %</th>
                            <th>VAT Amount</th>
                            <th>Amount</th>
                            <th>Batch No</th>
                            <th>expDate</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(itemData?.grnDetails) && itemData?.grnDetails.map((row, index) => (
                            <tr key={index}>
                                <td className='m-0 p-0' style={{ border: "1px solid rgba(118, 118, 118, 0.3)" }}><div className='center'> <RxCross1 size={15} /></div></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row?.srno} style={{ width: "80px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row?.itemCode} style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row?.itemDescription} style={{ width: "300px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row?.specification} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="number" value={row?.qty} style={{ width: "90px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row?.uom} style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row?.convToInvUOM * row.qty || 0} style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="number" value={Number(row?.unitPrice || 0).toFixed(currencyPrecision || 0)} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row?.discount} style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={(row?.vatPerc + "%") || 0} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={Number(row?.vatAmount || 0).toFixed(currencyPrecision || 0) || 0} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={(Number(row?.amount || 0).toFixed(currencyPrecision || 0) || 0) || 0} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row?.batchNo} style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled type='date' value={row?.expDate ? row.expDate.split('T')[0] : ''} style={{ width: "130px" }} /></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='d-flex justify-content-between boxs'>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Discount</div>
                    <div className='field'>---</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Amount</div>
                    <div className='field'>{totalAmount?.toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Discount</div>
                    <div className='field'>---</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Total Vat</div>
                    <div className='field'>{totalVat?.toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
                <div className='d-flex gap-2'>
                    <div className="totalhead center">Net Amount</div>
                    <div className='field'>{netAmount?.toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
            </div>
        </div>
    );
};

export default DirectPurchaseViewGrid;